

import { ModelSelect, ModelListSelect  } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'





import UMUM from         '../../library/umum'
import FETCHING from  '../../library/fetching'
import FUNCTIONS from  '../../library/function'

export default {
  components: {
     ModelSelect, ModelListSelect,  
  },
  data() {
    return {
      form : {
        id : '',
        bentuk : '',
        sifat : '',
        type : 0,
        judul : '',
        perihal : '',
        nomor : '',
        konseptor : '',
        unit_kerja : '',
        unit_kerja_uraian : '',
        penanda_tangan : '',
        status_ttd : '',
        tgl_ttd : '',
        isi : '',
        keterangan : '',
        lampiran : null,
        lampiran_type : '',
        pengagenda : '',
        status_agenda : '',
        tgl_agenda : '',
        status : '',
        user_nama : '',
        dikembalikan : '',
        ttd_dikembalikan : '',
      },

      borang_template :'',
     
      list_data : [],
      list_penandatangan : [],
      list_pemeriksa : [],
      list_penerima : [],

      list_penerima_final : [],

      filterku : {
        instansi_id : '',
        unit_kerja_id : '',
        unit_kerja_search : '',
        biodata_id :null,
        status_id : '',
      },


      page_first: 1,
      page_last: 0,
      page_limit : 10,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
      mdl_lamp : false,
      mdl_add_instansi: false,
      mdl_add_instansi_edit: false,

      mdl_fileLampiran: false,
      mdl_viewPenerima: false,
      mdl_viewPemeriksa: false,
      mdl_viewPPenandaTangan: false,

      ambil_semua_unit_kerja : false,

      UMUM : UMUM,
      FETCHING : FETCHING,
      FUNCTIONS : FUNCTIONS,

      fileOld : '',

      step: 1,

      content: 'asdas',
    }
  },
  methods: {


    insertTable(){
      let tableModule = this.$refs.myQuillEditor.quill.getModule('better-table')
      tableModule.insertTable(3, 3)
    },
    getView : function(){

      this.cek_load_data = true;
      // this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.office_sk_konsepSurat + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              unit_kerja : this.form.unit_kerja,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              // this.$store.commit("hideLoading");
              this.cek_load_data = false;
              console.log(res_data);
      });
    },

    addData : function() {
      var formData = new FormData();
      formData.append('form', JSON.stringify(this.form));
      formData.append('list_penandatangan', JSON.stringify(this.list_penandatangan));
      formData.append('list_pemeriksa', JSON.stringify(this.list_pemeriksa));
      formData.append('list_penerima', JSON.stringify(this.list_penerima));
      formData.append('file', this.form.lampiran);

      fetch(this.$store.state.url.office_sk_konsepSurat + "AddData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
        this.list_penandatangan = []
        this.list_pemeriksa = []
        this.list_penerima = []
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.mdl_add = false;
          // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
          this.step = 1
      });
      // console.log(this.form.bentukkategorilokasi)
    },
    editData : function(){
      var step = this.$refs.stepper.contentKey

      console.log(step)



      if (step==2) {
        this.nextIsi()
        // console.log('ambil')
      }

      var formData = new FormData();
      formData.append('form', JSON.stringify(this.form));
      formData.append('fileOld', this.fileOld);
      formData.append('file', this.form.lampiran);

      setTimeout(() => {
        fetch(this.$store.state.url.office_sk_konsepSurat + "editData", {
            method: "POST",
            headers: {
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      }, 110);
    },

    editDataPemeriksa : function(){
      fetch(this.$store.state.url.office_sk_konsepSurat + "editData", {
          method: "POST",
          headers: {
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    editDataPenandaTangan : function(){
      fetch(this.$store.state.url.office_sk_konsepSurat + "editData", {
          method: "POST",
          headers: {
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    editDataPenerima : function(){
      fetch(this.$store.state.url.office_sk_konsepSurat + "editData", {
          method: "POST",
          headers: {
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    convertPDF : async function(){
      await this.FETCHING.convertSurat(this.form.id, this.form.type, this.fileOld);
      this.Notify('Pembaharuan data berhasil disimpan', 'warning', 'check_circle_outline');
      this.step = 1
    },

    removeDataAll : function(E){
      fetch(this.$store.state.url.office_sk_konsepSurat + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id, file : this.fileOld})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },

    removeData : async function(data, route){
      await FUNCTIONS.postDataRemove(data, route);
      await this.asyncFunc(this.form.id)
      this.Notify('Sukses Menghapus Data', 'warning', 'check_circle_outline');
    },

    selectData : function(data){
      // console.log(data)
        this.form.id = data.id
        this.form.bentuk = data.bentuk
        this.form.sifat = data.sifat
        this.form.type = data.type
        this.form.judul = data.judul
        this.form.perihal = data.perihal
        this.form.nomor = data.nomor
        this.form.konseptor = data.konseptor
        this.form.unit_kerja_uraian = data.unit_kerja_uraian,
        this.form.unit_kerja = data.unit_kerja
        this.form.penanda_tangan = data.penanda_tangan
        this.form.status_ttd = data.status_ttd
        this.form.tgl_ttd = data.tgl_ttd
        this.form.isi = data.isi
        this.form.keterangan = data.keterangan
        // this.form.lampiran = data.lampiran
        this.fileOld = data.lampiran

        this.form.lampiran_type = data.lampiran_type
        this.form.pengagenda = data.pengagenda
        this.form.status_agenda = data.status_agenda
        this.form.tgl_agenda = data.tgl_agenda
        this.form.status = data.status
        this.form.user_nama = UMUM.namaLengkap(data.biodata_gelar_depan, data.biodata_nama, data.biodata_gelar_belakang)

        this.form.dikembalikan = data.dikembalikan
        this.form.ttd_dikembalikan = data.ttd_dikembalikan

        this.asyncFunc(data.id)

        
    },

    selectBorang : async function(){
      // await this.$store.commit('addEditorDinamicID', 'textarea#editorx')
      var isi = await this.FETCHING.postBorang(this.borang_template);
      this.form.isi = isi[0].borang

      var myEditor = document.querySelector('#editor')
      var html = myEditor.children[0].innerHTML = this.form.isi
    },

    nextIsi : function(){
      if (this.form.type == 1) {
        this.$store.commit('getQuillcontent', '#editor')
        this.form.isi = this.$store.state.content
      } 
    },

    backIsi : function(){
      if (this.form.type == 1) {
        setTimeout(() => {
          var myEditor = document.querySelector('#editor')
          myEditor.children[0].innerHTML = this.form.isi
        }, 105);
      } 
    },

    filterUnitKerja : function (val, update, abort) {
        update(() => {
          if (val === '') {}
          else {FETCHING.postUnitKerjaAuto(val)}
        })
    },

    filterBiodata : function (val, update, abort) {
        update(() => {
          if (val === '') {}
          else {FETCHING.postBiodataAuto(this.filterku.unit_kerja_id, val)}
        })
    },

    pushBiodata(){
      this.list_pemeriksa.push({
        biodata_id : this.filterku.biodata_id.id,
        nama : this.filterku.biodata_id.nama,
        nip : this.filterku.biodata_id.nip,
        gelar_belakang : this.filterku.biodata_id.gelar_belakang,
        gelar_depan : this.filterku.biodata_id.gelar_depan,
        unit_kerja : this.filterku.biodata_id.unit_kerja,
        unit_kerja_uraian : this.filterku.biodata_id.unit_kerja_uraian,
        jabatan_uraian: this.filterku.biodata_id.jabatan_uraian,
      })

    },

    addPemeriksa : async function(data, route, list){
      data.index = (list.length);
      data.surat_id = this.form.id;
      data.unit_pengirim = this.form.unit_kerja;

      await FUNCTIONS.postData(data, route)
      this.asyncFunc(this.form.id)
      this.Notify('Sukses menambah Data', 'warning', 'check_circle_outline');
    },

    addPenerima : async function(data, route, list){

      var penerima = await {
        index : (list.length)+1,
        surat_id : this.form.id,
        unit_pengirim : this.form.unit_kerja,
        listData : data,
      }

      await FUNCTIONS.postData(penerima, route)
      this.asyncFunc(this.form.id)
      this.Notify('Sukses menambah Data', 'warning', 'check_circle_outline');
      this.mdl_add_instansi_edit = false;
      this.list_penerima = [];
    },

    hapusBiodata(index){
      var data = parseInt(index)
      this.list_pemeriksa.splice(data, 1); 

    },

    pushPenandaTangan(){
      this.list_penandatangan.push({
        biodata_id : this.filterku.biodata_id.id,
        nama : this.filterku.biodata_id.nama,
        nip : this.filterku.biodata_id.nip,
        gelar_belakang : this.filterku.biodata_id.gelar_belakang,
        gelar_depan : this.filterku.biodata_id.gelar_depan,
        unit_kerja : this.filterku.biodata_id.unit_kerja,
        unit_kerja_uraian : this.filterku.biodata_id.unit_kerja_uraian,
        jabatan_uraian: this.filterku.biodata_id.jabatan_uraian,
      })

    },

    hapusPenandaTangan(index){
      var data = parseInt(index)
      this.list_penandatangan.splice(data, 1); 
    },

    hapusPenerima : function(index){
      var data = parseInt(index)
      this.list_penerima.splice(data, 1); 
    },

    searchUnitKerja : function(){
      this.FETCHING.postUnitKerjaSearch(this.filterku.unit_kerja_search)
    },

    resetStatus : async function(data){
      if (data == 'resetStatusTtd') {
        await this.FETCHING.resetStatusTtd(this.form);
        this.mdl_viewPPenandaTangan = false;
        
      } else if (data == 'resetStatusPemeriksa') {
        await this.FETCHING.resetStatus(this.form);
        this.mdl_viewPemeriksa = false;
      }
      this.getView();
    },

    CheckSemuaUnitKerja : function(){
      var data = this.list_penerima
      var dataStore = this.$store.state.list_unit_kerja_search


      if(this.ambil_semua_unit_kerja){
          this.$store.state.list_unit_kerja_search.forEach(element => {
            var nano = this.list_penerima.includes(element);
            if (!nano) {
              this.list_penerima.push(element)
            }
          });
      }else{
          this.$store.state.list_unit_kerja_search.forEach(elementStore => {
            var nano = this.list_penerima.includes(elementStore);
            if (nano) {
              var index = this.list_penerima.indexOf(elementStore);
              if (index > -1) { //if found
                this.list_penerima.splice(index, 1);
              }
            }
          });

      }
    },

    asyncFunc : async function(surat_id){
      this.list_pemeriksa = await this.FETCHING.postOnePemeriksa(surat_id);
      this.list_penandatangan = await this.FETCHING.postOnepenandaTangan(surat_id);
      this.list_penerima_final = await this.FETCHING.postOnePenerima(surat_id);
    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        

    // ====================================== PAGINATE ====================================



  },

  mounted () {

    var get_profile = JSON.parse(localStorage.profile);
    this.form.unit_kerja = get_profile.profile.unit_kerja;

    this.FETCHING.getBentuk();
    this.FETCHING.getSifat();
    this.FETCHING.getBorang();

    this.FETCHING.postUnitKerjaAuto('')
    this.FETCHING.postBiodataAuto('','')

    this.getView();

  },
}
